export const PLEDGE_COLUMNS = [
    { key: "pledgeId", label: "Pledge #", align: "text-right" },
    { key: "pledgeDate", label: "Date", align: "text-right" },
    { key: "pledgeAmount", label: "Amount", align: "text-right" },
    { key: "amountPaid", label: "Amount Paid", align: "text-right" },
    { key: "outstandingAmount", label: "Outstanding Amount", align: "text-right" },
    { key: "payOutSchedule", label: "Payout Schedule", align: "text-left" },
    { key: "actions", label: "", align: "text-center" }
];



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/pledgeTableConfig.js